import { useState } from "react";

import { Button } from "@icg360/design-system";

import { type PolicyPaymentDataQuery } from "gql/__generated__/hooks";
import { EditMortgageeModal } from "pages/settings/payment/payment-item/edit-mortgagee/edit-mortgagee-modal";
import { trackEvent } from "utils";

type EditMortgageeProps = {
  mortgagee: NonNullable<
    NonNullable<PolicyPaymentDataQuery["userBilling"]>["mortgagees"]
  >[number];
  policyId: string;
  keystonePolicyId: string;
};

const EditMortgagee = ({
  mortgagee,
  policyId,
  keystonePolicyId,
}: EditMortgageeProps) => {
  const [showEditModal, setShowEditModal] = useState(false);

  const openModal = () => {
    setShowEditModal(true);
    trackEvent("Edit mortgagee modal displayed");
  };

  return (
    <>
      <Button
        appearance="tertiary"
        size="xs"
        onPress={openModal}
        data-testid="edit-mortgagee-btn"
      >
        Edit
      </Button>
      <EditMortgageeModal
        open={showEditModal}
        onClose={() => setShowEditModal(false)}
        keystonePolicyId={keystonePolicyId}
        policyId={policyId}
        index={mortgagee.index ?? 0}
      />
    </>
  );
};

export default EditMortgagee;
